export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/patterntap/cal-e66a31f9bf27968b6a453f907e97d13c.png";